export const OVERLAY_DELAYS = {
    CROUTON: 50,
    HALFCARD_AND_MODAL: 50,
};

export const CROUTON_CLOSE_DELAY = 500; // In ms
